import { useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";

import SuperUserAPIService from "users/entities/super-user/api/super-user-api-service";
import PendingUserEntityMemberInvitation from "users/values/pending-user-entity-member-invitation/pending-user-entity-member-invitation";
import PendingUserEntityMemberInvitationsTable from "users/values/pending-user-entity-member-invitation/view/pending-user-entity-member-invitations-table";
import { useSession } from "users/session/session-context";
import { CanceledError } from "axios";
import Container from "@mui/material/Container";
import { styled } from "@mui/material";


const StyledInvitationsContainer = styled(Container)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2),
  },
  padding: theme.spacing(6),
  position: "relative",
  overflowY: "auto", 
  height: "100%"
}));

export default function ActiveUserInvitationsPage() {
  const [invitations, setInvitations] = useState<PendingUserEntityMemberInvitation[]>([]);
  const session = useSession();

  useEffect(() => {
    let abortController = new AbortController();
    void getActiveInvitations(abortController);
    return () => {
      abortController.abort();
      abortController = new AbortController();
    };
  }, []);

  async function getActiveInvitations(abortController: AbortController) {
    try {
      const superUserAPIService = new SuperUserAPIService(session);
      const returnedInvitations =
        await superUserAPIService.getActiveUserInvitations(abortController);
      setInvitations(returnedInvitations);
    } catch (error) {
      if (error instanceof CanceledError) return;
      console.error(error);
      enqueueSnackbar("Failed to get open invitations", { variant: "error" });
    }
  }

  return (
    <StyledInvitationsContainer>
      <PendingUserEntityMemberInvitationsTable
        invitations={invitations}
      />
    </StyledInvitationsContainer>
  );
}
